module.exports = __webpack_public_path__ + "media/svg/tn-878a7338.svg";